import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Intervention } from '../domain/planning/intervention';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root',
})
export class ExportService extends BaseService {

    private serviceUrl = `${environment.serviceMainBaseUrl}api/export`;

    constructor(
        protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
) {
        super(coreData, router, snackBare);
    }

    /**
     * @todo remove CODE PRODUCTEUR
     * @param group - grouped files or not
     *      @enum {boolean} true => grouped  1 file
     *      @enum {boolean} false => non grouped  multiple files
     */
    generateSaisieMinVCEExport(interventionList: Intervention[], group: boolean) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/saisieminvce/${group}`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getSaisieminvce')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateSoutienBioMinVCEExport(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/soutienbiominvce/`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateSoutienBioMinVCEExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateSoutienBioDiatExport(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/soutienbiodiatce/`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateSoutienBioDiatExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateOSURExport(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/OSUR`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getOSUR')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateEchangeListeExport(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/EchangeListeDiat/`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateEchangeListeExport')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateMphytCE(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/MphytCE/`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateMphytCE')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateREZip(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/RE`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateREList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateRIZip(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/RI`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateRIZip')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateRPZip(interventionList: Intervention[]) {
        const dto = Object.assign({});
        dto.InterventionCodes = interventionList.map(x => x.Code);
        const body = JSON.stringify(dto);
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/RP`, body, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateRPZip')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    generateREDraft(interventionCode: string) {
        const dto = Object.assign({});
        this.loadingTask.activateLoading();
        return this.http.post(`${this.serviceUrl}/REDraft/${interventionCode}`, null, this.generateHeader()).pipe(
            catchError(this.handleError<any>('generateREDraft')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: string) => {
                return response;
            }));
    }

    // generateStandardLacExport(sampleCode: string) {

    //     return this.http.post(`${this.serviceUrl}/standard/${sampleCode}`, null, this.generateHeader()).pipe(
    //         catchError(this.handleError<any>('getEchangeListeDiat')),
    //         finalize(() => this.loadingTask.deactivateLoading()),
    //         map((response: string) => {
    //             return response;
    //         }));
    // }

    fetchExport(filename: string) {
        window.open(`${this.serviceUrl}/${encodeURI(filename)}`, '_blank');
    }

    
    getExportALL() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}`, this.generateHeaderForFileDownload()).pipe(
            catchError(this.handleError<any>('getExportALL')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map(x => x));
    }
}
